import panzoom from 'panzoom';
import {ev} from '../Helper/index';
import {isEmpty, isNil} from "../Helper";

export default function initMapZoom() {
  const map = document.querySelector('#map');
  const mapHolder = document.querySelector('.map-holder');
  const btnZoomUp = document.querySelector('#map-zoom-up');
  const btnZoomDown = document.querySelector('#map-zoom-down');
  const mapRect = map.getBoundingClientRect();
  const mapWidthCenter = mapRect.width / 2;
  const mapHeightCenter = mapRect.height / 2;
  const zoomUpStep = 1.5;
  const zoomDownStep = 0.625;

  const mapOptions = {
    bounds: true,
    boundsPadding: 1,
    maxZoom: 7,
    minZoom: 1,
    initialX: mapWidthCenter,
    initialY: mapHeightCenter,
    initialZoom: 2,
    beforeWheel: function (e) {
      const shouldIgnore = !e.altKey;
      return shouldIgnore;
    },
    onTouch: function (e) {
      if (!e.target.closest('[id^="POI-"]')) {
        e.preventDefault();
      }
      return false;
    }
  };

  // Initial position and zoom settings for focussed POI
  // https://github.com/anvaka/panzoom#set-initial-position-and-zoom
  // https://stackoverflow.com/a/26423749/1517316
  const focussedElementIdentifier = mapHolder.dataset.focussedElementIdentifier;
  if (!isEmpty(focussedElementIdentifier)) {
    const poi = map.getElementById(focussedElementIdentifier);
    if (!isNil(poi)) {
      const mapHolderPosition = mapHolder.getBoundingClientRect();
      const poiPosition = poi.getBoundingClientRect();

      const relativePoiPositionLeft = poiPosition.left - mapHolderPosition.left;
      const relativePoiPositionTop = poiPosition.top - mapHolderPosition.top;

      mapOptions.initialX = relativePoiPositionLeft;
      mapOptions.initialY = relativePoiPositionTop;
      mapOptions.initialZoom = 4;
    }
  }


  const eventName = 'mapChanged';

  const mapInstance = panzoom(map, mapOptions);

  mapInstance.on('transform', function () {
    ev(eventName);
  });

  btnZoomUp.addEventListener('click', function (e) {
    e.stopPropagation();
    mapInstance.smoothZoom(mapWidthCenter, mapHeightCenter, zoomUpStep);
  })

  btnZoomDown.addEventListener('click', function (e) {
    e.stopPropagation();
    mapInstance.smoothZoom(mapWidthCenter, mapHeightCenter, zoomDownStep);
  })
}
